import { useSyncExternalStore } from 'react'
import type { ToastState, ToastTone } from '../../../components/toast'

/**
 * Feedback toasts for the recording surfaces, rendered by the global
 * controller stacked ABOVE the REC bar (the shared bottom toast slot is where
 * the bar sits, so a regular toast would cover its controls).
 */
let current: ToastState | null = null
let timer: ReturnType<typeof setTimeout> | null = null
const listeners = new Set<() => void>()

const DURATION_MS = 3500

function emit(): void {
  listeners.forEach((listener) => listener())
}

export function showRecordingToast(message: string, tone: ToastTone = 'success'): void {
  current = { message, tone }
  if (timer) clearTimeout(timer)
  timer = setTimeout(
    () => {
      current = null
      timer = null
      emit()
    },
    tone === 'error' ? DURATION_MS * 2 : DURATION_MS,
  )
  emit()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => current

export function useRecordingToast(): ToastState | null {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

/** Test helper. */
export function resetRecordingToastForTests(): void {
  if (timer) clearTimeout(timer)
  timer = null
  current = null
}
